import api from '~api'

export const url = `/intern-list`

export async function getInternships () {
  const {
    data
  } = await api.get(`${url}`)

  const internships = data.data.map((intern) => {
    return {

      college_id: intern.id,
      college_name: intern.title,
      departments: intern.internLists.map((dept) => {
        return {
          department_id: dept.id,
          department_name: dept.info,
          department_inter_link: dept.link
        }
      })

    }
  })

  return (internships)
}
